'use client';
var classes = {"root":"m_4081bf90"};

export { classes as default };
//# sourceMappingURL=Group.module.css.mjs.map
